import { useContext } from "react";
import { createContext } from "react";
import { useAuth } from "./AuthProvider";
import { useQuery } from "@tanstack/react-query";
import { getAdminUserPermissions } from "../helpers/http_admin_users_requests";

const PermissionsContext = createContext({});

export function PermissionsProvider({ children }) {

    const { id } = useAuth();

    const { data, isFetching } = useQuery({ queryKey: ['getAdminUserPermissions', id], queryFn: () => getAdminUserPermissions(id), staleTime: 1000 * 5, enabled: Boolean(id) });

    const { data: permissions = {} } = data?.data ?? {};

    function verifyPermission(name, required) {

        return parseInt(permissions[name]) >= parseInt(required);
    };

    const homeArea = permissions.home_area;

    const sharedValues = {
        homeArea,
        permissions,
        verifyPermission,
        isFetchingPermissions: isFetching,
    };

    return (
        <PermissionsContext.Provider
            value={sharedValues} >
            {children}
        </PermissionsContext.Provider>
    );
};

export function usePermissions() {
    return useContext(PermissionsContext);
};